import { render, staticRenderFns } from "./CodeContent.vue?vue&type=template&id=0da1b592&scoped=true&"
import script from "./CodeContent.vue?vue&type=script&lang=ts&"
export * from "./CodeContent.vue?vue&type=script&lang=ts&"
import style0 from "./CodeContent.vue?vue&type=style&index=0&id=0da1b592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da1b592",
  null
  
)

export default component.exports